import request from './request'

export interface UploadResponse {
  code: number
  msg: string
  data: {
    url?: string
    path?: string
    file?: string
    file_name?: string
    [key: string]: unknown
  }
}

export interface UploadParams {
  file: File
  category?: string
}

/** POST `/api/admin/upload` — 头像等通用上传（与技师头像相同） */
export async function uploadFile(params: UploadParams): Promise<UploadResponse> {
  const formData = new FormData()
  formData.append('category', params.category ?? 'general')
  formData.append('file', params.file)

  return request.post<UploadResponse>('/api/admin/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}
